import React, {useContext, useState, useEffect} from 'react';
import { Link } from "react-router-dom";
import { errorMessage } from '../errorHandler';
import resourcesServices from '../services/resourcesServices';
import TextControl from '../components/customizedInputs/TextControl';
import SelectControl from '../components/customizedInputs/SelectControl';
import { InputContext } from '../contexts/InputContext';

const PedirCancion = () => {
  const [authInformation, setAuthInformation, checkSignIn] = useContext(InputContext)

  const [saving, setSaving] = useState(false);
  const [renderHTML, setRenderHTML] = useState(false);
  const generos = ["salsa", "bachata", "kizomba"]
  const [cancion, setCancion] = useState({
    genero: null,
    cancion: ""
  });

  useEffect(() => {
    checkSignIn()
  }, []);


  useEffect(() => {
      setRenderHTML(authInformation.autenticado === true)

  }, [authInformation]);

  const guardar = async () => {
    try {
      setSaving(true)

      const copyCancion = {...cancion}
      copyCancion.user_uuid = authInformation.uuid

      await resourcesServices.crearResource('musica_pedidos', {musica_pedido: copyCancion});
      setCancion({genero: null, cancion: ""});
      alert("Gracias por tu pedido")

      setSaving(false)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    setCancion({...cancion,
      [name]: value
    })

  }

  return (
    <div className="container p-0 bg-main-usuario d-flex flex-column align-items-center">
      <div className='m-auto'>
        <h3 className='mb-3'>Pedir canción</h3>
      {
        renderHTML ? (
          <>
            {saving ? (
                <>
                <div className="position-absolute top-0 start-0 w-100 h-100">
                  <h3 className='mt-3 text-center'>Aguarde</h3>
                </div>

                </>
              ) : (
                <>
                  <div className='mb-3'>
                    <SelectControl
                        value={cancion.genero}
                        options={generos}
                        name={`genero`}
                        handleInput={handleInput}
                        label={'Cuál es el género?'}
                      />
                  </div>
                  <div className='mb-3'>
                    <TextControl
                      value={cancion.cancion}
                      name={'cancion'}
                      label={'Canción'}
                      handleInput={handleInput}
                    />
                  </div>
                  <div className="mb-5">
                    <button disabled={saving}  className="btn btn-primary" onClick={() => guardar()} type="button">
                      {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                      <span role="status">Enviar</span>
                    </button>
                  </div>
                  <Link className="btn btn-danger d-block mb-3" to={`/menu-usuario/${authInformation.uuid}`}>Volver</Link>
                </>
              )}
          </>
        ) : (
          <>
          Sin acceso
          </>
        )
      }
      </div>
    </div>
  );
};

export default PedirCancion;